import { theme } from '../theme';
import { Icon, IconName } from './Icon';

export type Tab = 'dashboard' | 'add' | 'budget' | 'history' | 'trends' | 'goals' | 'inbox';

const ITEMS: { id: Tab; icon: IconName; label: string }[] = [
  { id: 'dashboard', icon: 'home',   label: 'Дом' },
  { id: 'budget',    icon: 'wallet', label: 'Бюджет' },
  { id: 'add',       icon: 'plus',   label: 'Внести' },
  { id: 'history',   icon: 'list',   label: 'Свод' },
  { id: 'trends',    icon: 'trend',  label: 'Тренды' },
  { id: 'goals',     icon: 'map',    label: 'Карта' },
];

export function Nav({
  active,
  onChange,
  inboxCount,
}: {
  active: Tab;
  onChange: (t: Tab) => void;
  inboxCount?: number;
}) {
  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: theme.colors.card,
        borderTop: `1px solid ${theme.colors.line}`,
        paddingBottom: 'env(safe-area-inset-bottom)',
        zIndex: 50,
      }}
    >
      <div
        style={{
          maxWidth: theme.maxWidth,
          margin: '0 auto',
          display: 'flex',
          padding: '6px 8px',
        }}
      >
        {ITEMS.map((it) => {
          const on = active === it.id;
          const badge = it.id === 'inbox' && inboxCount && inboxCount > 0 ? inboxCount : null;
          return (
            <button
              key={it.id}
              onClick={() => onChange(it.id)}
              aria-label={it.label}
              style={{
                flex: 1,
                padding: '10px 0 8px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                color: on ? theme.colors.ink : theme.colors.sub,
                fontFamily: theme.font,
                position: 'relative',
              }}
            >
              <div style={{ lineHeight: 1, display: 'flex', justifyContent: 'center' }}>
                <Icon name={it.icon} size={22} stroke={on ? 1.6 : 1.2} />
              </div>
              <div
                style={{
                  fontSize: 9,
                  marginTop: 5,
                  letterSpacing: 1,
                  textTransform: 'uppercase',
                }}
              >
                {it.label}
              </div>
              {badge !== null && (
                <span
                  style={{
                    position: 'absolute',
                    top: 2,
                    right: 'calc(50% - 22px)',
                    background: theme.colors.ink,
                    color: theme.colors.paper,
                    fontSize: 10,
                    minWidth: 16,
                    height: 16,
                    borderRadius: 0,
                    padding: '0 4px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {badge}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
